import {useContext} from "react";
import OrderContext from "../contexts/OrderContext.tsx";
import {List, Link, TextField, Container, Paper, Stack, Box, Tooltip, IconButton} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AuthContext from "../contexts/AuthContext.tsx";
import {useTranslation} from "react-i18next";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import {useNavigate} from "react-router-dom";
import i18n from "i18next";
import SaleContext from "../contexts/SaleContext.tsx";
import AddIcon from "@mui/icons-material/Add";
import DiscountCodeContext from "../contexts/DiscountCodeContext.tsx";

const ProfilePage = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    // const [editing, setEditing] = useState<boolean>(false)
    const {isAdmin, user} = useContext(AuthContext)
    const {discountCodes} = useContext(DiscountCodeContext)
    const {sales} = useContext(SaleContext)
    const {orders, addTrackingIdMutation, sendShippingConfirmationMail} = useContext(OrderContext)

    const handleAddTrackingId = (orderId?: string, trackingId?: string) => {
        const updateObject = {orderId: orderId, trackingId: trackingId}
        addTrackingIdMutation.mutate(updateObject)
        sendShippingConfirmationMail(trackingId, orderId, i18n.language)
    }

    const renderStars = (rating: number) => {
        return (
            <Typography component="span">
                {[1, 2, 3, 4, 5].map((i) => (
                    <span
                        key={i}
                        style={{
                            color: i <= rating ? "gold" : "lightgray",
                            fontSize: "20px",
                            marginRight: "2px",
                        }}
                    >
          ★
        </span>
                ))}
            </Typography>
        );
    };

    const getDHLTrackingLink = (trackingId: string) => {
        return `https://www.dhl.de/de/privatkunden.html?piececode=${trackingId}`
    }

    return (
        <Container sx={{padding: '12px'}}>
            <Paper
                elevation={4}

                sx={{
                    maxWidth: '900px',
                    margin: 'auto',
                    padding: 2,
                }}
            >
                <Typography variant="h4" sx={{mb: 2}}>{t('PROFILE_TEXT')}</Typography>
                {/*<Typography variant="h5">{t('PROFILE_INFORMATION_TEXT')}</Typography>*/}

                {/*<TextField*/}
                {/*    label="E-Mail"*/}
                {/*    type="email"*/}
                {/*    name="email"*/}
                {/*    value={''}*/}
                {/*    disabled={!editing}*/}
                {/*    fullWidth*/}
                {/*    margin="normal"*/}
                {/*/>*/}

                {/*<Button*/}
                {/*    variant={editing ? "contained" : "outlined"}*/}
                {/*    onClick={() => setEditing(!editing)}*/}
                {/*    sx={{mt: 2}}*/}
                {/*>*/}
                {/*    {editing ? t('SAVE_BUTTON_TEXT') : t('EDIT_BUTTON_TEXT')}*/}
                {/*</Button>*/}
                {isAdmin &&
                    <div>
                        <Typography variant="h6" sx={{mt: 3, fontWeight: 500}}>
                            {t('VALID_DISCOUNT_CODES')}
                        </Typography>

                        <List sx={{pr: 5}}>
                            {discountCodes && discountCodes.length > 0 ? (
                                discountCodes
                                    .filter((discountCode) => discountCode.used === false)
                                    .map((discountCode) => (
                                        <Paper
                                            elevation={3}
                                            sx={{
                                                mt: 2,
                                                padding: 2,
                                                borderRadius: '12px',
                                                width: '100%',
                                                '&:hover': {
                                                    transform: 'translateY(-2px)',
                                                },
                                                cursor: 'pointer',
                                            }}
                                            key={discountCode._id}
                                        >
                                            <Typography variant="h6" sx={{fontWeight: 500}}>
                                                {t('DISCOUNT_CODE')}: {discountCode.code}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {t('DISCOUNT_PERCENT_TEXT')}: {discountCode.discountPercent}%
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {t('DISCOUNT_TILL')}: {new Date(discountCode.expiresAt).toLocaleDateString()}
                                            </Typography>
                                        </Paper>
                                    ))
                            ) : <Box/>}
                        </List>
                        <Tooltip title={t("CREATE_DISCOUNT_CODE")}>
                            <IconButton
                                color={"primary"}
                                onClick={() => navigate('/create-discount-code')}
                            >
                                <AddIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                }
                {isAdmin &&
                    <div>
                        <Typography variant="h6" sx={{mt: 3, fontWeight: 500}}>
                            {t('SALES')}
                        </Typography>

                        <List sx={{pr: 5}}>
                            {sales && sales.length > 0 ? (
                                sales.map((sale) => (
                                    <Paper
                                        elevation={3}
                                        sx={{
                                            mt: 2,
                                            padding: 2,
                                            borderRadius: '12px',
                                            width: '100%',
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                            },
                                            cursor: 'pointer',
                                        }}
                                        key={sale._id}
                                        onClick={() => {
                                            navigate(`/edit-sale/${sale._id}`)
                                        }}
                                    >
                                        <Typography variant="h6" sx={{fontWeight: 500}}>
                                            {t('SALE_TEXT')}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {t('SALE_FROM_TEXT')}: {new Date(sale.from).toLocaleDateString()}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {t('SALE_TO_TEXT')}: {new Date(sale.to).toLocaleDateString()}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {t('SALE_DISCOUNT_TEXT')}: {sale.discount * 100}%
                                        </Typography>
                                    </Paper>
                                ))
                            ) : <Box/>}
                        </List>
                        <Tooltip title={t("CREATE_SALE")}>
                            <IconButton
                                color={"primary"}
                                onClick={() => navigate('/create-sale')}
                            >
                                <AddIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                }
                <Typography variant="h6" sx={{fontWeight: 500}}>
                    {isAdmin ? t('ALL_ORDERS_TEXT') : t('MY_ORDERS_TEXT')}
                </Typography>

                <List sx={{pr: 5}}>
                    {orders && orders.length > 0 ? (
                        orders.map((order) => (
                            order.isPaid &&
                            <Paper
                                elevation={3}
                                sx={{
                                    mt: 2,
                                    padding: 2,
                                    borderRadius: '12px',
                                    width: '100%',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                    },
                                    cursor: 'pointer',
                                }}
                                key={order._id}
                                onClick={() => navigate(`/order/${order._id}`)}
                            >
                                <Typography variant="h6" sx={{fontWeight: 500}}>
                                    {t('ORDER_NUMBER_TEXT')}: {order.orderNumber}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {t('ORDER_DATE_TEXT')}: {new Date(order.createdAt!).toLocaleDateString()}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {t('CART_PAGE_SUM_TEXT')}: <strong>{order.totalPrice + order.shippingCost} €</strong>
                                </Typography>

                                {order.isShipped ? (
                                    <Stack direction="row" alignItems="center" spacing={1} sx={{mt: 1}}>
                                        <LocalShippingIcon color="success"/>
                                        <Typography variant="body2" sx={{fontWeight: 500, color: "green"}}>
                                            {t('STATE_SENT_TEXT')}
                                        </Typography>
                                        <Link
                                            href={getDHLTrackingLink(order.trackingId!)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{ml: 1}}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            Tracking ID: {order.trackingId}
                                        </Link>
                                    </Stack>
                                ) : (
                                    <Typography variant="body2" sx={{mt: 1, fontWeight: 500, color: "orange"}}>
                                        {t('STATE_NOT_SENT_TEXT')}
                                    </Typography>
                                )}

                                {isAdmin && !order.isShipped && (
                                    <TextField
                                        placeholder={t('TRACKING_ID_PLACEHOLDER_TEXT')}
                                        onClick={(e) => e.stopPropagation()}
                                        onBlur={(e) => {
                                            handleAddTrackingId(order._id, e.target.value);
                                        }}
                                        fullWidth
                                        size="small"
                                        sx={{mt: 1}}
                                    />
                                )}
                                <Stack direction="row" alignItems="center" spacing={2} sx={{mt: 2}}>
                                    {!order.reviewed ?
                                        order.user === user!._id && <Button
                                            variant="outlined"
                                            size="small"
                                            color="primary"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/create-review/${order._id}`);
                                            }}
                                        >
                                            {t('REVIEW_TEXT')}
                                        </Button> :
                                        <Box>
                                            <Typography
                                                variant="body2"
                                                sx={{display: 'flex', alignItems: 'center'}}
                                            >
                                                {t('REVIEW_WITH_TEXT')}{renderStars(order.reviewed.rating)}
                                            </Typography>

                                            {user?._id === order.reviewed.user &&
                                                <Box sx={{pt: 1}}>
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            navigate(`/edit-review/${order.reviewed._id}/of/${order._id}`);
                                                        }}
                                                    >
                                                        {t("EDIT_REVIEW")}
                                                    </Button>

                                                </Box>
                                            }
                                        </Box>
                                    }
                                </Stack>
                            </Paper>
                        ))
                    ) : (
                        <Typography variant="body2">{t('NO_ORDERS_TEXT')}</Typography>
                    )}
                </List>
            </Paper>
        </Container>
    )
}

export default ProfilePage